import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'imv-faq',
  standalone: false,
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {

  @Input() easyRead: boolean = false;
  @Output() navigateQuestionnaireEmmiter: EventEmitter<boolean> = new EventEmitter();

  navigateQuestionnaire(): void {
    this.navigateQuestionnaireEmmiter.emit(true);
  }
}
